@import './ui-cms-teaser-group-article';

/* stylelint-disable declaration-no-important */
@mixin default-item-styles {
  [bars-visible] {
    margin-top: 80px;
  }

  div.mgnlEditorBar {
    margin-top: 60px !important;
    /* stylelint-disable-next-line function-no-unknown */
    margin-left: gutter() !important;
    /* stylelint-disable-next-line function-no-unknown */
    margin-right: gutter() !important;
    top: -35px;
  }
}

ui-cms-teaser-group-article {
  display: block;

  [bars-visible] {
    margin-top: 15px;
  }

  div.mgnlEditorBar {
    margin-top: 30px !important;
    width: 100% !important;
  }

  .teaser-group-article {
    &--2,
    &--3 {
      div.mgnlEditorBar.area {
        width: 100% !important;
      }
    }

    &--2 {
      @include breakpoint($small) {
        @include default-item-styles();

        [bars-visible] {
          /* stylelint-disable-next-line function-no-unknown */
          margin-left: -1 * span(6 of 12);
        }

        div.mgnlEditorBar {
          /* stylelint-disable-next-line function-no-unknown */
          width: calc(#{span(6 of 12)} - #{2 * gutter()}) !important;
        }

        &.column-distribution {
          &--4_8 > {
            .area.focus ~ ui-cms-container:nth-of-type(odd),
            .area.childFocus ~ ui-cms-container:nth-of-type(odd),
            [bars-visible]:nth-of-type(odd) {
              /* stylelint-disable-next-line function-no-unknown */
              margin-left: -1 * span(4 of 12);
            }

            div.mgnlEditorBar.component:nth-of-type(odd) {
              /* stylelint-disable-next-line function-no-unknown */
              width: calc(#{span(8 of 12)} - #{2 * gutter()}) !important;
            }

            .area.focus ~ ui-cms-container:nth-of-type(even),
            .area.childFocus ~ ui-cms-container:nth-of-type(even),
            [bars-visible]:nth-of-type(even) {
              /* stylelint-disable-next-line function-no-unknown */
              margin-left: -1 * span(8 of 12);
            }

            div.mgnlEditorBar.component:nth-of-type(even) {
              /* stylelint-disable-next-line function-no-unknown */
              width: calc(#{span(4 of 12)} - #{2 * gutter()}) !important;
            }
          }

          &--8_4 > {
            .area.focus ~ ui-cms-container:nth-of-type(odd),
            .area.childFocus ~ ui-cms-container:nth-of-type(odd),
            [bars-visible]:nth-of-type(odd) {
              /* stylelint-disable-next-line function-no-unknown */
              margin-left: -1 * span(8 of 12);
            }

            div.mgnlEditorBar.component:nth-of-type(odd) {
              /* stylelint-disable-next-line function-no-unknown */
              width: calc(#{span(4 of 12)} - #{2 * gutter()}) !important;
            }

            .area.focus ~ ui-cms-container:nth-of-type(even),
            .area.childFocus ~ ui-cms-container:nth-of-type(even),
            [bars-visible]:nth-of-type(even) {
              /* stylelint-disable-next-line function-no-unknown */
              margin-left: -1 * span(4 of 12);
            }

            div.mgnlEditorBar.component:nth-of-type(even) {
              /* stylelint-disable-next-line function-no-unknown */
              width: calc(#{span(8 of 12)} - #{2 * gutter()}) !important;
            }
          }
        }
      }
    }

    &--3 {
      @include breakpoint($medium) {
        @include default-item-styles();

        [bars-visible] {
          /* stylelint-disable-next-line function-no-unknown */
          margin-left: -1 * span(4 of 12);
        }

        div.mgnlEditorBar {
          /* stylelint-disable-next-line function-no-unknown */
          width: calc(#{span(4 of 12)} - #{2 * gutter()}) !important;
        }
      }
    }
  }
}
